import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sproCarrierList: [],
    operationObj: { type: '', status: '' },
    isLoading: false,
    totalElements: 0,
};

export const SproCarrierManagementSlice = createSlice({
    name: 'sproCarrierManagementReducer',
    initialState,
    reducers: {
        updateSproCarrierList: (state, action) => {
            state.sproCarrierList = action.payload;
        },
        updateSproCarrierOperationObj: (state, action) => {
            state.operationObj = action.payload;
        },
        updateSproCarrierIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        updateSproCarrierTotalElements: (state, action) => {
            state.totalElements = action.payload;
        },
    },
});

export const {
    updateSproCarrierList,
    updateSproCarrierOperationObj,
    updateSproCarrierIsLoading,
    updateSproCarrierTotalElements,
} = SproCarrierManagementSlice.actions;

// Selector
export const getSproCarrierManagementSelector = (state) => state.sproCarrierManagementReducer;

export default SproCarrierManagementSlice.reducer;